import { removeLocalStorage,getLocalStorage,setLocalStorageJSON } from '../util/metodos'

const INITIAL_STATE = {
    user: getLocalStorage(),
    validToken: false,
    // Login aceito pelo backend mas aguardando a confirmacao do codigo enviado
    // ao usuario. Fica so em memoria: um F5 volta para a tela de login.
    validacao: null

}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'TOKEN_VALIDATED':
            if (action.payload) {
                return { ...state, validToken: true }
            } else {
                removeLocalStorage()
                return { ...state, validToken: false, user: null }
            }

        case 'VALIDACAO_PENDENTE':
            return { ...state, validacao: action.payload, user: null, validToken: false }

        case 'VALIDACAO_CANCELADA':
            return { ...state, validacao: null }

        case 'USER_FETCHED':
            setLocalStorageJSON(JSON.stringify(action.payload))
            return { ...state, user: action.payload, validToken: true, validacao: null }

        default:
            return state
    }
}